import React, { useEffect } from "react";
import { Typography } from "@material-ui/core";
import { GameModalLayout, FilePreview } from "../common";
import { store } from "../../redux/store";
import { checkGameStatus, navigateGameScreen } from "../../service/logic";
import { GAME_STAGE } from "../../utils/constant";
import { history } from "../../index";
import Button from "@material-ui/core/Button";
import { setGameStatus } from "../../redux/dispatchers";
import { makeStyles } from "@material-ui/core/styles";
import { fontSize } from "../../styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  button: {
    display: "flex",
    marginRight: 25,
    paddingLeft: 35,
    paddingRight: 35,
    backgroundColor: "#1D3557",
    borderRadius: 16,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: fontSize.h5,
    "&:hover": {
      backgroundColor: "#457B9D",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: 20,
      paddingRight: 20,
      fontSize: fontSize.h6,
    },
    [theme.breakpoints.down("xs")]: {
      padding: 10,
      marginRight: -5,
      marginTop: -5,
      width: 130,
      height: 40,
      fontSize: fontSize.h5,
      textTransform: "none",
    },
  },
}));

const CaseSummary = () => {
  const classes = useStyles();
  const { link } = store.getState().gameStates.case.summary;

  useEffect(() => {
    // check if user is allowed to enter page
    if (!checkGameStatus(GAME_STAGE.CASE_SUMMARY)) {
      // if not allowed, navigate to case list page
      history.push("/cases");
    }
  }, []);

  return (
    <React.Fragment>
      <GameModalLayout
        full
        left={
          <>
            <div className={classes.container}>
              <Typography variant="h2" style={{ display: "flex" }}>
                Case Summary
              </Typography>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={() => {
                  setGameStatus(store.getState().gameStates.status - 1);
                  navigateGameScreen(0);
                }}
              >
                Back to Dashboard
              </Button>
            </div>
            <FilePreview url={link[0] || ""} />
          </>
        }
      />
    </React.Fragment>
  );
};

export default CaseSummary;
